
import { fetchAuthSession } from 'aws-amplify/auth';
import { BedrockRuntimeClient, InvokeModelCommand } from '@aws-sdk/client-bedrock-runtime';

const GenerateSceneAdaption = async (setImages, prompt, style, image) => {
    const session = await fetchAuthSession()

    const bedrockClient = new BedrockRuntimeClient({
        region: 'us-east-1',
        credentials: session.credentials
    });
    const modelId = "amazon.nova-canvas-v1:0"; // "amazon.titan-image-generator-v2:0";

    const fullPrompt = "In a " + style + " style modify the image in the following way. " + prompt
    // console.log(fullPrompt)
    // console.log(image.replace("data:image/png;base64,", ""))
    const nativeRequest = {
        imageVariationParams: { images: [image.replace("data:image/png;base64,", "")], text: fullPrompt.slice(0, 512) },
        taskType: "IMAGE_VARIATION",
        imageGenerationConfig: {
            cfgScale: 8,
            seed: 0,
            width: 1024,
            height: 1024,
            numberOfImages: 3
        }
    };

    // console.log(JSON.stringify(nativeRequest))
    const body = new TextEncoder().encode(JSON.stringify(nativeRequest));

    const input = {
        body: body, // Required
        contentType: "application/json",
        accept: "application/json",
        modelId: modelId, // Required
        trace: "ENABLED"
    };

    const command = new InvokeModelCommand(input);

    try {
        const response = await bedrockClient.send(command);
        const modelResponse = JSON.parse(new TextDecoder().decode(response.body));
        const base64ImageData = modelResponse.images;

        // Set the image source to display the image in the component
        setImages(base64ImageData.map((value, key) => `data:image/png;base64,${value}`));
        return base64ImageData.map((value, key) => `data:image/png;base64,${value}`);
    } catch (error) {
        console.error('Error generating image:', error);
    }
};

export default GenerateSceneAdaption;